export const enGB_menu = {
	'app.menu.parent': 'Top Menu',
	'app.menu.dashboard': 'Dashboard',
	'app.menu.dashboard.workbench': 'Workbench',
	'app.menu.dashboard.analysis': 'Analysis',

	'app.menu.form': 'Form',
	'app.menu.form.basic': 'Basic Form',
	'app.menu.form.advanced': 'Advanced Form',
	'app.menu.form.editor': 'Editor',

	'app.menu.list': 'List',
	'app.menu.list.search': 'Search List',

	'app.result': 'Result',
	'app.result.success': 'Success',
	'app.result.failed': 'Failed',

	'app.abnormal': 'Abnormal',
	'app.abnormal.403': '403',
	'app.abnormal.404': '404',
	'app.abnormal.500': '500',

	'app.org': 'Org',
	'app.org.dept': 'Dept',
	'app.org.account': 'Account',
	'app.org.role': 'Role',
	'app.org.permission': 'Permission',

	'app.user': 'User',
	'app.user.center': 'User Center',
	'app.user.settings': 'User Settings',

	'app.menu.login': 'Login',
	'app.menu.config': 'Config',
	'app.menu.config.search': 'Menu Manage',
	'app.menu.config.code.search': 'Directory Manage',
	'app.menu.config.notice.search': 'Notice Manage',
	'app.menu.config.schedule.search': 'Schedule Manage',
	'app.menu.config.schedule.log': 'Schedule Log',
	'app.menu.config.theme': 'Theme Settings',
	'app.menu.logs': 'Logs',
	'app.menu.logs.search': 'Logs Manage',
	// Monitor center
	'app.menu.monitor': 'Monitor',
	'app.menu.monitor.online': 'Online Users',
	'app.menu.monitor.server': 'Server',
	// In-site messages
	'app.menu.notice': 'Notice',
	'app.menu.notice.message': 'In-site Messages',
	// AI capabilities
	'app.menu.ai': 'AI',
	'app.menu.ai.mcp.servers': 'MCP Servers',
	'app.menu.ai.llm.providers': 'LLM Providers',
	'app.menu.ai.llm.prompts': 'Prompts',
	'app.menu.ai.training': 'Training Ground',
	// System Configuration —— admin-only (userStore.role gated, will be controlled by sys_menu in backend)
	'app.menu.systemConfig': 'System Configuration',
	'app.menu.systemConfig.leadTemplate': 'Lead Templates',
	// CRM Leads
	'app.menu.crm': 'CRM',
	'app.menu.crm.lead.template': 'Lead Templates',
	'app.menu.crm.lead.fields': 'Lead Templates', // schema viewer (read-only)
	'app.menu.crm.lead.source': 'Intake Config',
	'app.menu.crm.lead.mapping': 'Field Mappings',
	'app.menu.crm.lead.rule': 'Distribution Rules',
	'app.menu.crm.lead.pool': 'Lead Pool',
	'app.menu.crm.lead.list': 'Lead List',
	'app.menu.followPlan': 'Follow Plans',
	'app.menu.h5Preview': 'H5 Preview',
	// WeCom
	'app.menu.wecom': 'WeCom Management',
	'app.menu.wecom.activeCode': 'Live Codes',
	'app.menu.wecom.colleague': 'Colleagues',
	'app.menu.wecom.group': 'Group Chats',
	'app.menu.wecom.customer': 'Customers'
}
